


















import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import VuePhoneNumberInput from 'vue-phone-number-input';
import parsePhoneNumber from 'libphonenumber-js';
import { isNullOrEmpty } from '../utils';

@Component({
    components: { VuePhoneNumberInput }
})
export default class InputPhone extends Vue {
    @Prop({ default: '' }) value!: string;
    @Prop({ default: false }) isRequired!: boolean;
    
    countryCode: string = 'UY';
    internalValue: any = '';

    translations: object = {
        countrySelectorLabel: 'Código País',
        countrySelectorError: 'Elegir un país',
        phoneNumberLabel: 'Número de teléfono',
        example: 'Ejemplo:'
    };

    preferredCountries: string[] = ['UY', 'BR', 'AR', 'PY'];

    mounted() {
        this.processPhoneNumber(this.value);
    }

    @Watch('value', { immediate: true })
    onValueChange(newValue: string) {
        this.processPhoneNumber(newValue);
    }

    processPhoneNumber(phone: string) {
        if (!phone) return;
        try {
            const parsedPhone = parsePhoneNumber(phone);
            if (parsedPhone) {
                this.internalValue = parsedPhone.number;
                if(parsedPhone.country){
                    this.countryCode = parsedPhone.country;
                }
            } else {
                this.internalValue = phone;
            }
        } catch (error) {
            this.internalValue = phone;
        }
    }

    changeValue(value: any) {
        if (value && value.formattedNumber) {
            try {
                const parsedPhone = parsePhoneNumber(value.formattedNumber);
                if (parsedPhone) {
                    this.updateValue(parsedPhone.number); // Emitir número completo
                } else {
                    this.updateValue(value.formattedNumber);
                }
            } catch (error) {
                this.updateValue(value.formattedNumber);
            }
        }
    }

    @Emit()
    updateValue(value: string) {
        return value;
    }

    get isValid() {
        if (!this.isRequired) {
            return true;
        }
        return !isNullOrEmpty(this.internalValue);
    }
}
